// extracted by mini-css-extract-plugin
export default {"Container":"I9DNEBe6zG23uPFGnyYB","Title":"B8UYSDuMe9pF2b5WzZzW","MessagesContainer":"JDx7MnlE9UqwCbGjCS8N"};